import { Helmet } from "react-helmet-async";

function NotFound() {
 return (
  <>
   <Helmet>
    <title>404 Not Found | SportingHip</title>
    <meta name="robots" content="noindex,nofollow" />
   </Helmet>

   <div
    style={{
     minHeight: "70vh",
     display: "flex",
     flexDirection: "column",
     justifyContent: "center",
     alignItems: "center",
     textAlign: "center",
     padding: "20px",
    }}
   >
    <h1>404</h1>
    <p>This page does not exist.</p>
   </div>
  </>
 );
}

export default NotFound;
